import type { TimeCategory } from '../../api';
import { UNCATEGORIZED, UNCATEGORIZED_VALUE } from '../../format';

/** The category choices of a select: the project's categories, then "Ohne Kategorie" - nothing typed in. */
export function categoryChoices(categories: readonly TimeCategory[], long = true): { value: string; label: string }[] {
  return [
    ...categories.map((c) => ({ value: c.id, label: long ? `${c.code}${c.label ? ` – ${c.label}` : ''}` : c.code })),
    { value: UNCATEGORIZED_VALUE, label: UNCATEGORIZED },
  ];
}

/** A select value back to the API's category id; "Ohne Kategorie" is null. */
export const categoryOf = (value: string): string | null => (value === UNCATEGORIZED_VALUE ? null : value);
